var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo__container",class:_vm.logoPosition,style:(_vm.spacing)},[_c('a',{staticClass:"app-logo",attrs:{"href":"/"}},[_c('img',{staticClass:"app-logo__image",attrs:{"alt":_vm.altText,"src":_vm.imgSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }